import { useCart } from '../CartContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useState } from "react"
import DeliveryModal from "./Components/DeliveryModal"
import HomeImage1 from "../assets/Home/HomeImage1.png"
import HomeImage2 from "../assets/Home/HomeImage2.png"
import HomeImage3 from "../assets/Home/HomeImage3.png"
import HomeImage4 from "../assets/Home/HomeImage4.png"
import HomeImage5 from "../assets/Home/HomeImage5.png"
import HomeImage6 from "../assets/Home/HomeImage6.png"
import HomeImage7 from "../assets/Home/HomeImage7.png"
import HomeImage8 from "../assets/Home/HomeImage8.png"
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';

const Home = () => {
    const { cartItems } = useCart();
    const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
    const [showMenuModal, setShowMenuModal] = useState(false);

    const homeImages = [
        HomeImage1,
        HomeImage2,
        HomeImage3,
        HomeImage4,
        HomeImage5,
        HomeImage6,
    ];

    return (
        <div className="bg-[#F5F5DC]">
            {/* Navbar */}
            <Navbar totalQuantity={totalQuantity} />


            {/* Hero Section */}
            <section className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-12 md:py-20 bg-orange-400">
                <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-20">
                    <div className="w-full lg:w-1/2 flex flex-col gap-6 md:gap-8">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight md:leading-snug lg:leading-[67px]">
                            Welcome to Parsley: A Taste of Syria
                        </h1>
                        <p className="text-base md:text-lg leading-relaxed">
                            At Parsley, we invite you to savor the authentic flavors of Syria through our carefully crafted BBQ dishes. Join us for a culinary journey that celebrates rich traditions and vibrant tastes.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                type="button"
                                onClick={() => setShowMenuModal(true)}
                                className="px-6 py-3 bg-black text-white text-base font-normal text-center hover:bg-gray-800 transition"
                            >
                                Explore
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowMenuModal(true)}
                                className="px-6 py-3 border border-black text-black text-base font-normal text-center hover:bg-black hover:text-white transition"
                            >
                                Menu
                            </button>
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2 grid grid-cols-2 gap-4 mt-8 lg:mt-0">
                        {homeImages.map((image, i) => (
                            <div key={i} className="aspect-square bg-gray-200 rounded overflow-hidden">
                                <img
                                    src={image}
                                    alt={`Food ${i + 1}`}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Weekend Specials */}
            <section className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-16 md:py-28 bg-black">
                <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 md:gap-20">
                    <div className="w-full lg:w-1/2">
                        <div className="aspect-[4/5] bg-gray-800 rounded overflow-hidden">
                            <img
                                src={HomeImage7}
                                alt="Weekend Specials"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2 flex flex-col gap-6 md:gap-8">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-orange-400">
                            Indulge in Our Weekend Specials!
                        </h2>
                        <p className="text-white text-base md:text-lg">
                            Join us this weekend for a delightful culinary experience. Our specials feature mouthwatering dishes that celebrate the rich flavors of Middle Eastern BBQ.
                        </p>

                        <ul className="space-y-4">
                            {['Shish Taouk', 'Farouj Chicken', 'Syrian Appetizer Platter'].map((item, i) => (
                                <li key={i} className="flex items-start gap-4">
                                    <div className="w-4 h-4 mt-1 bg-orange-400 rounded-full flex-shrink-0"></div>
                                    <span className="text-white text-base md:text-lg">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            {/* Experience Section */}
            <section className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-16 md:py-28 bg-black">
                <div className="max-w-7xl mx-auto flex flex-col lg:flex-row-reverse items-center gap-12 md:gap-20">
                    <div className="w-full lg:w-1/2">
                        <div className="aspect-[4/5] bg-gray-800 rounded overflow-hidden">
                            <img
                                src={HomeImage8}
                                alt="Restaurant Experience"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2 flex flex-col gap-6 md:gap-8">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-400">
                            Experience the Authentic Flavors of the Middle East at Parsley
                        </h2>
                        <p className="text-white text-base md:text-lg">
                            At Parsley, we pride ourselves on using only the freshest ingredients, sourced locally. Our authentic recipes bring the rich flavors of the Middle East right to your table.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-white text-xl font-bold mb-2">Fresh Ingredients</h3>
                                <p className="text-white text-base">
                                    We select the finest produce to ensure every bite is bursting with flavor.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-white text-xl font-bold mb-2">Cozy Atmosphere</h3>
                                <p className="text-white text-base">
                                    Dine in a warm, inviting space perfect for gatherings with family and friends.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="w-full px-4 sm:px-6 md:px-8 lg:px-16 py-16 md:py-28 bg-stone-400">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 md:mb-20">Contact us</h2>

                    <div className="flex flex-col lg:flex-row gap-12 md:gap-20">
                        <div className="w-full lg:w-1/3 space-y-8 md:space-y-10">
                            <div>
                                <FontAwesomeIcon icon={faEnvelope} className="text-black text-2xl mb-4" />
                                <h3 className="text-xl font-bold mb-2">Email</h3>
                                <p className="mb-1">Reach us at</p>
                                <a href="mailto:parsleymiddletown@gmail.com" className="underline hover:text-orange-600 transition">
                                    parsleymiddletown@gmail.com
                                </a>
                            </div>

                            <div>
                                <FontAwesomeIcon icon={faPhone} className="text-black text-2xl mb-4" />
                                <h3 className="text-xl font-bold mb-2">Phone</h3>
                                <p className="mb-1">Call us today</p>
                                <a href="tel:8605807779" className="underline hover:text-orange-600 transition">
                                    (860) 580-7779
                                </a>
                            </div>

                            <div>
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-black text-2xl mb-4" />
                                <h3 className="text-xl font-bold mb-2">Location</h3>
                                <p className="mb-4">324 Main St Middletown, Connecticut 06457</p>
                                <a
                                    href="https://www.google.com/maps?q=324+Main+St+Middletown,+Connecticut+06457"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 underline hover:text-orange-600 transition"
                                >
                                    Get Directions
                                    <FontAwesomeIcon icon={faArrowRight} className="text-black text-sm" />
                                </a>
                            </div>
                        </div>

                        <div className="w-full lg:w-2/3">
                            <div className="aspect-video rounded overflow-hidden">
                                <iframe
                                    title="Google Map of 324 Main St Middletown"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2955.2034989211834!2d-72.65408292347736!3d41.56299757127137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e649dd6e45b97f%3A0x2d4007b3ec1d63c5!2s324%20Main%20St%2C%20Middletown%2C%20CT%2006457%2C%20USA!5e0!3m2!1sen!2ssa!4v1718350700000!5m2!1sen!2ssa"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    className="w-full h-full"
                                ></iframe>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />

            <DeliveryModal isOpen={showMenuModal} onClose={() => setShowMenuModal(false)} pickupPath="/menu" />
        </div>
    );
};

export default Home;
